import { FC, useEffect, useState } from "react";
import { Card, Col, Modal, Row, Spin, Steps } from "antd";
import Info from "../../components/product/addAndEdit/Info";
import PriceOption from "../../components/product/addAndEdit/PriceOption";
import Stock from "../../components/product/addAndEdit/Stock";
import "../../styles/_switch.scss";
import "../../styles/_steps.scss";

import { productType } from "../../types/product";
import { UploadFile } from "antd/lib";
import { useQuery } from "@tanstack/react-query";
import { productDetails } from "../../network/products";
import { useIntl } from "react-intl";

interface EditProductFormProps {
  editProductData?: any;
  visible: boolean;
  onClose: () => void;
}

const EditProductForm: FC<EditProductFormProps> = ({
  editProductData,
  visible,
  onClose,
}) => {
  const intl = useIntl();
  const { data: productData, isLoading: isProductLoading } = useQuery(
    ["product", editProductData?.id],
    () => {
      if (!editProductData?.id) return;
      return productDetails(
        editProductData?.category_id,
        editProductData?.id,
        true
      );
    }
  );
  const [current, setCurrent] = useState(0);
  const [product, setProduct] = useState<
    Omit<productType, "name"> & { name: { en: string; ar: string } }
  >(null as any);
  const [productImg, setProductImg] = useState<UploadFile>(
    typeof editProductData?.media === "string"
      ? {
          uid: String(Math.random() + 9000),
          name: "productImg",
          url: editProductData?.media,
        }
      : ({} as any)
  );
  useEffect(() => {
    if (productData?.data) {
      console.log(productData?.data);
      setProduct(productData?.data);
    }
  }, [productData?.data]);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 532);
  const onNextStep = () => {
    setCurrent(current + 1);
  };

  const steps = [
    {
      sec_title: intl.formatMessage({ id: "completeProductInfo" }),
      title: intl?.formatMessage({ id: "product_pricing" }),
      component: product ? (
        <Info
          onNextStep={onNextStep}
          onClose={onClose}
          // product={editProductData}
          setProduct={setProduct}
          product={product}
          productImg={productImg}
          setProductImg={setProductImg}
          update={true}
        />
      ) : (
        <div className="h-full w-full flex items-center justify-center">
          <Spin size="large" />
        </div>
      ),
    },
    {
      sec_title: intl.formatMessage({ id: "completeProductPriceInfo" }),

      title: intl?.formatMessage({ id: "product_pricing" }),
      component: product ? (
        <Stock
          onNextStep={onNextStep}
          onClose={onClose}
          // product={editProductData}
          setProduct={setProduct}
          product={product}
        />
      ) : (
        <div className="h-full w-full flex items-center justify-center">
          <Spin size="large" />
        </div>
      ),
    },
    {
      sec_title: intl.formatMessage({ id: "completeProductPriceInfo" }),
      title: intl?.formatMessage({ id: "product_inventory" }),
      component: product ? (
        <PriceOption
          onClose={onClose}
          //  product={editProductData}
          setProduct={setProduct}
          product={product}
          update={true}
          productImg={productImg}
        />
      ) : (
        <div className="h-full w-full flex items-center justify-center">
          <Spin size="large" />
        </div>
      ),
    },
  ];
  const onChange = (value: number) => {
    if (current < value) {
      return;
    }
    setCurrent(value);
  };

  const onCancel = () => {
    onClose();
  };

  const currentStepComponent = steps[current].component;
  return (
    <Modal
      destroyOnClose
      centered
      open={visible}
      onCancel={onCancel}
      okButtonProps={{ disabled: true }}
      cancelButtonProps={{ disabled: true }}
      footer={[]}
      width={1200}
      className="custom-modal" // Add a custom class here
    >
      {isProductLoading && editProductData?.id && product ? (
        <div className="h-full w-full flex items-center justify-center">
          <Spin size="large" />
        </div>
      ) : (
        <div className="mt-9 flex gap-4 flex  justify-center content-center">
          <div className="normalSteps min-w-[200px] ">
            <Steps
              current={current}
              items={steps}
              direction={isSmallScreen ? "horizontal" : "vertical"}
              onChange={onChange}
              responsive={false}
              className="vertical-steps "
              style={{ height: "140%" }}
              size="small"
            />
          </div>
          <div className="w-full">
            <Card>
              <div className="text-color-primary text-2xl font-semibold text-center ">
                {intl.formatMessage({ id: "edit_product" })}
              </div>
              {steps.map((step, index) =>
                current === index ? (
                  <div
                    key={index}
                    className="my-4 text-color-gray text-base font-normal text-center"
                  >
                    {step.sec_title}
                  </div>
                ) : null
              )}

              {currentStepComponent}
            </Card>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default EditProductForm;
